export default "__VITE_ASSET__CSE_9oUA__"